// src/components/LiveHeader.tsx
import React from "react";
import PageTitle from "./PageTitle";

export default function LiveHeader({
  shouldBeListening,
  listeningSinceMs,
  lastHeardAgoSec,
  rightControls,
}: {
  shouldBeListening: boolean;
  listeningSinceMs: number;
  lastHeardAgoSec: number | null;
  rightControls?: React.ReactNode;
}) {
  return (
    <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 8 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <PageTitle>Live Session</PageTitle>
        <span
          className={`badge ${shouldBeListening ? "badge-success" : "badge-muted"}`}
          aria-live="polite"
          style={{ fontSize: 12 }}
        >
          {shouldBeListening
            ? `Listening (System) • since ${new Date(listeningSinceMs).toLocaleTimeString()}${lastHeardAgoSec !== null ? ` • last heard ${lastHeardAgoSec}s ago` : ""}`
            : "Stopped"}
        </span>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {rightControls}
      </div>
    </div>
  );
}
